import { DateRangeType, SortByType } from 'src/components/search-listing/utils/types';
import { ProfileStatus } from 'src/types/UserInfo';

export const getDefaultThreadListingSortBy = (profileStatus: ProfileStatus) => {
  if (profileStatus === ProfileStatus.registered) {
    return SortByType.relevance;
  }
  return SortByType.lastActivityTime;
};

export const getDefaultThreadListingDateRange = () => DateRangeType.threeMonths;

export const sortByValidation = (sortBy: any) => !!sortBy
  && Object.values(SortByType).includes(sortBy);

export const dateRangeValidation = (dateRange: any) => !!dateRange
&& (Object.values(DateRangeType).includes(dateRange));
